import React from 'react'
import Header from '../../Components/Header'
import ToolingAndManufacturing from '../../Components/toolingAndManufacturing'

const ToolingAndManufacturingPage = () => {
    return (
        <div >
        <Header />
            <ToolingAndManufacturing />
        </div>
    )
}

export default ToolingAndManufacturingPage